import { IIconBase } from '..'

const peopleIcon = ({
  color = '#333752',
  height = 25,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 7.23618C17.94 7.22618 17.87 7.22618 17.81 7.23618C16.43 7.18618 15.33 6.05617 15.33 4.65617C15.33 3.22617 16.48 2.07617 17.91 2.07617C19.34 2.07617 20.49 3.23617 20.49 4.65617C20.48 6.05617 19.38 7.18618 18 7.23618Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.97 14.5162C18.34 14.7462 19.85 14.5062 20.91 13.7962C22.32 12.8562 22.32 11.3162 20.91 10.3762C19.84 9.66618 18.31 9.42618 16.94 9.66618'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.97 7.23618C6.03 7.22618 6.1 7.22618 6.16 7.23618C7.54 7.18618 8.64 6.05617 8.64 4.65617C8.64 3.22617 7.49 2.07617 6.06 2.07617C4.63 2.07617 3.48 3.23617 3.48 4.65617C3.49 6.05617 4.59 7.18618 5.97 7.23618Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 14.5162C5.63 14.7462 4.12 14.5062 3.06 13.7962C1.65 12.8562 1.65 11.3162 3.06 10.3762C4.13 9.66618 5.66 9.42618 7.03 9.66618'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 14.7062C11.94 14.6962 11.87 14.6962 11.81 14.7062C10.43 14.6562 9.33 13.5262 9.33 12.1262C9.33 10.6962 10.48 9.54617 11.91 9.54617C13.34 9.54617 14.49 10.7062 14.49 12.1262C14.48 13.5262 13.38 14.6662 12 14.7062Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.09 17.8562C7.68 18.7962 7.68 20.3362 9.09 21.2762C10.69 22.3462 13.31 22.3462 14.91 21.2762C16.32 20.3362 16.32 18.7962 14.91 17.8562C13.32 16.7962 10.69 16.7962 9.09 17.8562Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default peopleIcon
